import * as React from 'react'
import type { SVGProps } from 'react'
function SvgStadtEnergieverbrauchAb238456407511(
  props: SVGProps<SVGSVGElement>,
) {
  return (
    <svg
      viewBox="0 0 233.4 221"
      x="0px"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      xmlSpace="preserve"
      y="0px"
      {...props}
    >
      <g>
        <path d="M203.7,142.4c-1.8,0-3.2,1.5-3.2,3.2v68.9H142v-83.4c0-1.8-1.5-3.2-3.2-3.2H87.3c-1.8,0-3.2,1.5-3.2,3.2v83.4H25.7V110.2 l86.7-72.5L134.8,56c1.4,1.1,3.4,0.9,4.6-0.5s0.9-3.4-0.5-4.6l-24.4-20c-1.2-1-2.9-1-4.1,0L6.5,117.8V96L112.4,7.5l29,24.1 c1.4,1.1,3.4,1,4.6-0.4c1.1-1.4,1-3.4-0.4-4.6L114.5,0.8c-1.2-1-3-1-4.2,0L1.2,92C0.4,92.6,0,93.5,0,94.5v30.2 c0,1.3,0.7,2.4,1.9,2.9c0.4,0.2,0.9,0.3,1.4,0.3c0.7,0,1.5-0.3,2.1-0.8l13.9-11.6v102.2c0,1.8,1.5,3.2,3.2,3.2h181.2 c1.8,0,3.2-1.5,3.2-3.2v-72.2C206.9,143.8,205.4,142.4,203.7,142.4z M90.6,134.3h44.9v80.2H90.6V134.3z" />
        <path d="M39.9,139.5c-1.8,0-3.2,1.5-3.2,3.2v41c0,1.8,1.5,3.2,3.2,3.2H70c1.8,0,3.2-1.5,3.2-3.2v-41c0-1.8-1.5-3.2-3.2-3.2H39.9z  M66.8,180.5H43.2V146h23.6V180.5z" />
        <path d="M159.1,146.5c0-1.8-1.5-3.2-3.2-3.2c0,0,0,0,0,0c-1.8,0-3.2,1.5-3.2,3.3l0.2,37.3c0,1.8,1.5,3.2,3.2,3.2h30.1 c0.9,0,1.7-0.3,2.3-1c0.6-0.6,0.9-1.5,0.9-2.3l-0.2-16.7c0-1.8-1.5-3.2-3.3-3.2c-1.8,0-3.2,1.5-3.2,3.3l0.2,13.4h-23.5L159.1,146.5 z" />
        <path d="M233,50.2c-0.6-1-1.7-1.6-2.8-1.6h-30.7l12.6-40.2c0.3-1,0.1-2.1-0.5-2.9C211,4.7,210,4.2,209,4.2l-47.7,0.1 c-1.6,0-3,1.2-3.2,2.9l-9.7,79.2c-0.1,0.9,0.2,1.9,0.8,2.5c0.6,0.7,1.5,1.1,2.4,1.1h21v56.6c0,1.5,1,2.8,2.4,3.1 c0.3,0.1,0.6,0.1,0.8,0.1c1.1,0,2.2-0.6,2.8-1.6L233,53.5C233.6,52.5,233.6,51.2,233,50.2z M179.1,134.4V86.8 c0-1.8-1.5-3.2-3.2-3.2h-20.6l8.9-72.7l40.4-0.1l-12.6,40.2c-0.3,1-0.1,2.1,0.5,2.9c0.6,0.8,1.6,1.3,2.6,1.3h29.6L179.1,134.4z" />
      </g>
    </svg>
  )
}
export default SvgStadtEnergieverbrauchAb238456407511
